import React from 'react'
import { Route } from 'react-router-dom'
import { IndexReport, ReportCreate, ReportEdit, ReportMain, ReportView } from '../Views/Web/Report/Index'
import ClientReportLayout from '../Views/Web/Report/Component/Client/ClientLayout'
import ClientReport from '../Views/Web/Report/Component/Client/Clientt/Client'
import SurveyReport from '../Views/Web/Report/Component/Client/Survey-Report/Survey-Report'
import ContractReport from '../Views/Web/Report/Component/Client/Contract/Contract'
import InspectionLayout from '../Views/Web/Report/Component/Inspection/InspectionLayout'
import InScheduleReport from '../Views/Web/Report/Component/Inspection/Schedule/Schedule'
import CommisioningLayout from '../Views/Web/Report/Component/Commisioning/CommisioningLayout'
import ScheduleReport from '../Views/Web/Report/Component/Commisioning/Schedule/Schedule'
import RefillingLayout from '../Views/Web/Report/Component/Refilling/RefillingLayout'
import FireExtinguisherReport from '../Views/Web/Report/Component/Refilling/FireExtinguisher/FireExtinguisher'
import FireSuppressionReport from '../Views/Web/Report/Component/Refilling/FireSuppression/FireSuppression'
import TicketsLayout from '../Views/Web/Report/Component/Tickets/TicketsLayout'
import ClientTicketsReport from '../Views/Web/Report/Component/Tickets/ClientTickets/ClientTickets'
import SupportTicketsReport from '../Views/Web/Report/Component/Tickets/SupportTickets/SupportTickets'
import TaskReport from '../Views/Web/Report/Component/Task/Task'
import InvoiceLayout from '../Views/Web/Report/Component/Invoice/InvoiceLayout'
import OutgoingReport from '../Views/Web/Report/Component/Invoice/Outgoing/Outgoing'

function ReportRoutes() {
  return (
    <Route path="report" element={<ReportMain/>}>
      <Route index element={<IndexReport/>} />
      <Route path='client-Management' element={<ClientReportLayout/>} >
       <Route path='client' element={<ClientReport/>}/>
       <Route path='survey-report' element={<SurveyReport/>}/>
       <Route path='contract' element={<ContractReport/>}/>

      </Route>
      <Route path='inspection' element={<InspectionLayout/>} >
       <Route path='inschedule' element={<InScheduleReport/>}/>

      </Route>
      <Route path='commisioning' element={<CommisioningLayout/>} >
       <Route path='schedule' element={<ScheduleReport/>}/>

      </Route>

      <Route path='refilling' element={<RefillingLayout/>} >
       <Route path='fireExtinguisher' element={<FireExtinguisherReport/>}/>
       <Route path='fireSuppression' element={<FireSuppressionReport/>}/>
       

      </Route>

      <Route path='tickets' element={<TicketsLayout/>} >
       <Route path='clientTickets' element={<ClientTicketsReport/>}/>
       <Route path='supportTickets' element={<SupportTicketsReport/>}/>
       

      </Route>

      <Route path='task' element={<TaskReport/>}/>

      <Route path='invoice' element={<InvoiceLayout/>} >
       <Route path='outgoing' element={<OutgoingReport/>}/>

      </Route>


    </Route>
  )
  }
  
  export default ReportRoutes